import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { Context as ReactContext, useContext, useEffect, useState } from 'react';

import { IMachineLearningExperiment } from '../../Common/MachineLearningModels/IMachineLearningExperiment';

export function useMachineLearningExperiments(): [IMachineLearningExperiment[], () => void] {
  const [experiments, setExperiments] = useState<IMachineLearningExperiment[]>([]); // [IExperiment
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  const loadExperiments = () => {
    httpClient
      .request<IMachineLearningExperiment[]>({
        url: `${__API_BASE_URL__}/machine-learning/experiments`,
        resource: __CLIENT_ID__,
      })
      .then(({ data }) => {
        setExperiments(data);
      });
  };

  useEffect(() => {
    loadExperiments();
  }, []);

  return [experiments, loadExperiments];
}
